import ClientStorage from '@naturehouse/nh-essentials/lib/storage/Storage';
import LocalStorageStrategy from '@naturehouse/nh-essentials/lib/storage/strategies/LocalStorageStrategy';
import type AbstractStorageStrategy from '@naturehouse/nh-essentials/lib/storage/strategies/AbstractStorageStrategy';

export default class AppPromotionBannerStorage {
    public static readonly DATABASE_NAME: string = 'AppPromotion';

    readonly #storageKey: string = 'calendar-banner-dismissed';

    public async isDismissed(): Promise<boolean> {
        const storage = await this.#getStorage();

        return (await storage.getItem(this.#storageKey)) === true;
    }

    public async markAsDismissed(): Promise<void> {
        const storage = await this.#getStorage();

        await storage.setItem(this.#storageKey, true);
    }

    async #getStorage(): Promise<AbstractStorageStrategy<boolean>> {
        return ClientStorage.retrieveStorage<boolean>(
            AppPromotionBannerStorage.DATABASE_NAME,
            LocalStorageStrategy
        );
    }
}
